import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    query {\n        allSubscriptionLevels {\n            id\n            code\n            name\n            description\n            descriptionLong\n            monthlyCostUSD\n            monthlyCostFormatted\n            numberOfUsesPerPeriod\n        }\n    } \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Header, Divider, Button, Grid, Sticky, Rail, Transition, Dimmer, Loader, Message } from 'semantic-ui-react';
import _ from 'lodash';
import gql from 'graphql-tag';
import { AccountClient, log, getLocalStorageWithExpiry } from '@emyw/core-lib';
import '../custom-theme.css';
import './Step1PlansMatrix.css';
import { setUserSubscriptionLevelByCode, normalizeErrors, DEFAULT_PROMO_CODE } from '../utils';
var _process$env = process.env,
    FREE = _process$env.REACT_APP_FREE_PLAN_CODE,
    STANDARD = _process$env.REACT_APP_STANDARD_PLAN_CODE,
    PREMIUM = _process$env.REACT_APP_PREMIUM_PLAN_CODE;
var allSubscriptionLevelsQuery = gql(_templateObject());
var REACT_APP_ENJOY_SITE_ROOT_URL = process.env.REACT_APP_ENJOY_SITE_ROOT_URL;

var Step1PlansMatrix = /*#__PURE__*/function (_React$Component) {
  _inherits(Step1PlansMatrix, _React$Component);

  var _super = _createSuper(Step1PlansMatrix);

  function Step1PlansMatrix(props, context) {
    var _this;

    _classCallCheck(this, Step1PlansMatrix);

    _this = _super.call(this, props, context);

    _this.handleContextRef = function (contextRef) {
      _this.setState({
        contextRef: contextRef
      });
    };

    _this.handleParentDivRef = function (parentDivRef) {
      return _this.setState({
        parentDivRef: parentDivRef
      });
    };

    _this.handleContinueClick = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, onContinueClick, userId, user, updateSubscriptionLevel, selectedPlan, updateSubscriptionHandler, callback;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, onContinueClick = _this$props.onContinueClick, userId = _this$props.userId, user = _this$props.user, updateSubscriptionLevel = _this$props.updateSubscriptionLevel;
              selectedPlan = _this.state.selectedPlan; // In the atypical case where we have a user loaded, update the server's plan now

              log.trace('Should we update subscription level:', userId, user); // if (userId && !(user || {}).signupCompletedOn) {

              if (userId && !(user || {}).signupCompletedOn || user && user.activeProfile && user.activeProfile.id > -1) {
                // if ((userId && !user) || (!(user || {}).signupCompletedOn && ((user || {}).activeProfile || { id: 0 }).id > -1)) {
                // const success = await this.updateSubscriptionLevel(userId, selectedPlan);
                // if (success) onContinueClick(selectedPlan);

                /* If updateSubscriptionLevel is passed in to props, call that function, otherwise call this.updateSubscriptionLevel */
                updateSubscriptionHandler = updateSubscriptionLevel || _this.updateSubscriptionLevel;
                /* Initialize a callback function for after plan has been updated */

                callback = function callback(_ref2) {
                  var ok = _ref2.ok,
                      errors = _ref2.errors;

                  // eslint-disable-line no-unused-vars
                  if (ok) {
                    onContinueClick(selectedPlan);
                  } else {
                    _this.setState({
                      errors: normalizeErrors(errors, 'general', true)
                    });
                  }
                };

                updateSubscriptionHandler(userId, user, selectedPlan, callback); // const { ok, errors } = await updateSubscriptionHandler(userId, selectedPlan);
              } else {
                onContinueClick(selectedPlan);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.handlePlanClick = function (planCode) {
      _this.setState({
        selectedPlan: planCode
      });
    };

    _this.updateSubscriptionLevel = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userId, user, selectedPlan, callback) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // try {
                _this.setState({
                  processing: true
                });

                log.trace('updateSubscriptionLevel', userId, user, _this.state, _this.props);
                _context2.next = 4;
                return setUserSubscriptionLevelByCode(userId, !selectedPlan ? FREE : selectedPlan);

              case 4:
                response = _context2.sent;
                if (!response.ok) _this.setState({
                  processing: false,
                  errors: ['There was an error processing your request. Please try again.']
                });
                callback(response); //     // return response.data.setUserSubscriptionLevelByCode;
                //     // const { ok, errors } = response.data.setUserSubscriptionLevelByCode;
                //     /* if (ok) {
                //         this.setState({ processing: false });
                //         return true;
                //     }
                //     this.setState({ errors: normalizeErrors(errors, 'general', true), processing: false });
                //     return false; */
                // } catch (errors) {
                //     // this.setState({ errors: [error.message], processing: false });
                //     // return false;
                //     callback({ ok: false, errors });
                //     // return { ok: false, errors };
                // }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.columnClassName = function (column) {
      var className = 'columnValue';

      if (column === _this.state.selectedPlan) {
        className = "".concat(className, " selectedColumnValue");
      }

      return className;
    };

    _this.columnColorStyle = function (column) {
      var darkMode = _this.props.darkMode;
      if (darkMode) return {}; // Let parent handle styles

      var color = 'gray';

      if (column === _this.state.selectedPlan) {
        color = column === 'FREE' ? 'black' : 'blue';
      } // color = column === 'FREE' ? 'lightgray' : 'black';


      return {
        color: color
      };
    };

    _this.updateDimensions = function () {
      var parentDivRef = _this.state.parentDivRef;
      var w = window;
      var d = document;
      var documentElement = d.documentElement;
      var body = d.getElementsByTagName('body')[0];
      var width = w.innerWidth || documentElement.clientWidth || body.clientWidth;

      if (parentDivRef) {
        var _parentDivRef$getBoun = parentDivRef.getBoundingClientRect();

        width = _parentDivRef$getBoun.width;
      }

      _this.setState({
        width: width
      });
    };

    _this.state = {
      processing: false,
      errors: [],
      selectedPlan: props.planCode || PREMIUM,
      width: 0,
      contextRef: undefined,
      freePlanMonthlyCost: undefined,
      standardPlanMonthlyCost: undefined,
      premiumPlanMonthlyCost: undefined,
      freePlanNumberOfUses: undefined,
      standardPlanNumberOfUses: undefined,
      premiumPlanNumberOfUses: undefined
    };
    return _this;
  }

  _createClass(Step1PlansMatrix, [{
    key: "componentWillMount",
    value: function () {
      var _componentWillMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.loadSubscriptionLevels();

              case 2:
                this.updateDimensions();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentWillMount() {
        return _componentWillMount.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.updateDimensions); // This next line seems hacky but works. Otherwise, the elements are not rendered enough to get width of the ref element

      setTimeout(function () {
        _this2.updateDimensions();
      }, 0); // see if there is a plan selection in the url

      var search = window.location.search;
      var urlParams = new URLSearchParams(search);

      if (urlParams.has('p')) {
        if (['FREE', 'STANDARD', 'PREMIUM'].includes(urlParams.get('p'))) {
          this.handlePlanClick(urlParams.get('p'));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "loadSubscriptionLevels",
    value: function () {
      var _loadSubscriptionLevels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response, show7DaysFree, stateUpdate;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return AccountClient.query({
                  query: allSubscriptionLevelsQuery,
                  fetchPolicy: 'network-only'
                });

              case 2:
                response = _context4.sent;
                show7DaysFree = true; // getLocalStorageWithExpiry('enjoy-promo-code') === DEFAULT_PROMO_CODE;

                stateUpdate = {};
                response.data.allSubscriptionLevels.forEach(function (sl) {
                  if (sl.code === FREE) {
                    Object.assign(stateUpdate, {
                      freePlanMonthlyCost: sl.monthlyCostFormatted,
                      freePlanNumberOfUses: sl.numberOfUsesPerPeriod
                    });
                  } else if (sl.code === STANDARD) {
                    Object.assign(stateUpdate, {
                      standardPlanMonthlyCost: show7DaysFree ? /*#__PURE__*/React.createElement(React.Fragment, null, sl.monthlyCostFormatted, " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
                        style: {
                          fontSize: '0.75em'
                        }
                      }, "7 days free")) : sl.monthlyCostFormatted,
                      standardPlanNumberOfUses: sl.numberOfUsesPerPeriod
                    });
                  } else if (sl.code === PREMIUM) {
                    Object.assign(stateUpdate, {
                      premiumPlanMonthlyCost: show7DaysFree ? /*#__PURE__*/React.createElement(React.Fragment, null, sl.monthlyCostFormatted, " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
                        style: {
                          fontSize: '0.75em'
                        }
                      }, "7 days free")) : sl.monthlyCostFormatted,
                      premiumPlanNumberOfUses: sl.numberOfUsesPerPeriod
                    });
                  }
                });
                this.setState(stateUpdate);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadSubscriptionLevels() {
        return _loadSubscriptionLevels.apply(this, arguments);
      }

      return loadSubscriptionLevels;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          contextRef = _this$state.contextRef,
          processing = _this$state.processing,
          errors = _this$state.errors,
          freePlanMonthlyCost = _this$state.freePlanMonthlyCost,
          premiumPlanMonthlyCost = _this$state.premiumPlanMonthlyCost,
          freePlanNumberOfUses = _this$state.freePlanNumberOfUses,
          standardPlanNumberOfUses = _this$state.standardPlanNumberOfUses,
          premiumPlanNumberOfUses = _this$state.premiumPlanNumberOfUses,
          selectedPlan = _this$state.selectedPlan;
      var _this$props2 = this.props,
          dialogMode = _this$props2.dialogMode,
          darkMode = _this$props2.darkMode,
          onContinueClick = _this$props2.onContinueClick,
          planCode = _this$props2.planCode,
          disableLowerPlanCodes = _this$props2.disableLowerPlanCodes,
          hideFreePlan = _this$props2.hideFreePlan; // const features = [
      //     { description: 'Family friendly filters', free: '✔', standard: '✔', premium: '✔' },
      //     { description: 'Movie trivia', free: '✔', standard: '✔', premium: '✔' },
      //     { description: 'Stylized subtitles', free: '✔', standard: '✔', premium: '✔' },
      //     {
      //         description: 'Shows per month',
      //         free: freePlanNumberOfUses,
      //         standard: standardPlanNumberOfUses,
      //         premium: premiumPlanNumberOfUses >= 5000 ? 'Unlimited' : premiumPlanNumberOfUses,
      //     },
      //     { description: 'Speed control', free: 'X', standard: '✔', premium: '✔' },
      //     { description: 'Picture enhancement', free: 'X', standard: '✔', premium: '✔' },
      //     { description: 'Volume normalization', free: 'X', standard: '✔', premium: '✔' },
      //     { description: 'Subtitle translation', free: 'X', standard: 'X', premium: '✔' },
      //     { description: 'All other special features', free: 'X', standard: 'X', premium: '✔' },
      // ];

      var features = [{
        description: 'Filtering',
        free: '✔',
        basic: '✔',
        standard: '✔',
        premium: '✔'
      }, // { description: 'Movie trivia', free: '✔', basic: '✔', standard: '✔', premium: '✔' },
      {
        description: 'Shows per month',
        free: freePlanNumberOfUses >= 5000 ? 'Unlimited w/breaks' : standardPlanNumberOfUses,
        standard: standardPlanNumberOfUses >= 5000 ? 'Unlimited' : standardPlanNumberOfUses,
        premium: premiumPlanNumberOfUses >= 5000 ? 'Unlimited' : premiumPlanNumberOfUses
      }, {
        description: 'Speed control',
        free: 'X',
        basic: '✔',
        standard: '✔',
        premium: '✔'
      }, {
        description: 'Subtitle translations',
        free: 'X',
        basic: '✔',
        standard: '✔',
        premium: '✔'
      } // { description: 'Picture enhancement', free: 'X', standard: '✔', premium: '✔' },
      // { description: 'Volume normalization', free: 'X', standard: '✔', premium: '✔' },
      // { description: 'Subtitle translation', free: 'X', standard: 'X', premium: '✔' },
      // { description: 'All other special features', free: 'X', standard: 'X', premium: '✔' },
      ];

      var featureRowWide = _.times(features.length, function (i) {
        return /*#__PURE__*/React.createElement(Grid.Row, {
          key: i,
          verticalAlign: "middle",
          className: "featureRow"
        }, /*#__PURE__*/React.createElement(Grid.Column, {
          computer: "8"
        }, features[i].description), !hideFreePlan && /*#__PURE__*/React.createElement(Grid.Column, {
          computer: "4",
          textAlign: "center",
          className: _this3.columnClassName(FREE),
          style: _this3.columnColorStyle(FREE)
        }, features[i].free), /*#__PURE__*/React.createElement(Grid.Column, {
          computer: "4",
          textAlign: "center",
          className: _this3.columnClassName(PREMIUM),
          style: _this3.columnColorStyle(PREMIUM)
        }, features[i].premium));
      });

      var featureRowNarrow = _.times(features.length, function (i) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: i,
          columns: 2,
          divided: true
        }, /*#__PURE__*/React.createElement(Grid.Row, {
          columns: "2",
          verticalAlign: "middle",
          className: "featureRowNarrow"
        }, /*#__PURE__*/React.createElement(Grid.Column, {
          width: "15",
          textAlign: "center"
        }, features[i].description)), /*#__PURE__*/React.createElement(Grid.Row, {
          verticalAlign: "middle",
          className: "featureRow"
        }, !hideFreePlan && /*#__PURE__*/React.createElement(Grid.Column, {
          width: "8",
          textAlign: "center",
          className: _this3.columnClassName(FREE),
          style: _this3.columnColorStyle(FREE)
        }, features[i].free), /*#__PURE__*/React.createElement(Grid.Column, {
          width: "8",
          textAlign: "center",
          className: _this3.columnClassName(PREMIUM),
          style: _this3.columnColorStyle(PREMIUM)
        }, features[i].premium)));
      });

      var Wrapper = function Wrapper(props) {
        return props.children;
      };

      return /*#__PURE__*/React.createElement("div", {
        className: "wizardStepBase selectPlan fluid",
        ref: this.handleParentDivRef
      }, processing && /*#__PURE__*/React.createElement(Transition, {
        visible: processing,
        animation: "scale",
        duration: 500
      }, /*#__PURE__*/React.createElement(Dimmer, {
        active: true,
        inverted: !darkMode
      }, /*#__PURE__*/React.createElement(Loader, {
        inverted: !darkMode
      }, "One Moment..."))), !dialogMode && /*#__PURE__*/React.createElement(Header, {
        color: "grey",
        as: "h2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "stepTitle"
      }, "Choose a plan that's right for you.", /*#__PURE__*/React.createElement(Header.Subheader, null, "Upgrade or downgrade at any time"))), /*#__PURE__*/React.createElement("div", {
        className: "subscribeStepContent"
      }, this.state.width > 400 && /*#__PURE__*/React.createElement("div", null, !dialogMode && /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), !dialogMode && /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), /*#__PURE__*/React.createElement(Grid, {
        columns: 4
      }, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Column, {
        computer: "8"
      }), !hideFreePlan && /*#__PURE__*/React.createElement(Grid.Column, {
        computer: "4",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        size: "large",
        onClick: function onClick() {
          return _this3.handlePlanClick(FREE);
        },
        disabled: disableLowerPlanCodes && planCode !== FREE,
        className: "planButton ".concat(selectedPlan === FREE ? 'freePlanSelected' : '')
      }, "Free")), /*#__PURE__*/React.createElement(Grid.Column, {
        computer: "4",
        textAlign: "center"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        size: "large",
        onClick: function onClick() {
          return _this3.handlePlanClick(PREMIUM);
        },
        primary: true,
        className: "planButton ".concat(this.state.selectedPlan === PREMIUM ? 'planSelected' : '')
      }, "Premium")))), /*#__PURE__*/React.createElement(Grid, {
        columns: 4,
        divided: "vertically"
      }, /*#__PURE__*/React.createElement(Grid.Row, {
        verticalAlign: "middle",
        className: "featureRow"
      }, /*#__PURE__*/React.createElement(Grid.Column, {
        computer: "8"
      }, "Monthly price"), !hideFreePlan && /*#__PURE__*/React.createElement(Grid.Column, {
        computer: "4",
        textAlign: "center",
        className: this.columnClassName(FREE),
        style: this.columnColorStyle(FREE)
      }, freePlanMonthlyCost), /*#__PURE__*/React.createElement(Grid.Column, {
        computer: "4",
        textAlign: "center",
        className: this.columnClassName(PREMIUM),
        style: this.columnColorStyle(PREMIUM)
      }, premiumPlanMonthlyCost)), featureRowWide)), this.state.width <= 400 && /*#__PURE__*/React.createElement("div", {
        className: "narrowContent"
      }, /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), !dialogMode && /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), !dialogMode && /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), /*#__PURE__*/React.createElement(Grid, {
        columns: 1
      }, /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement("div", {
        ref: this.handleContextRef
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Rail, {
        position: "right",
        internal: true,
        style: {
          width: '100%',
          zIndex: 1
        },
        attached: true
      }, /*#__PURE__*/React.createElement(Sticky, {
        context: contextRef,
        offset: 10
      }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, {
        style: {
          marginLeft: '3.5%',
          marginRight: '3.5%',
          textAlign: 'center'
        }
      }, !hideFreePlan && /*#__PURE__*/React.createElement(Grid.Column, {
        width: "8"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        onClick: function onClick() {
          return _this3.handlePlanClick(FREE);
        }
        /* eslint-disable-next-line max-len */
        ,
        className: "planButtonNarrow ".concat(this.state.selectedPlan === FREE ? 'freePlanSelected' : '')
      }, "Free"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(this.state.selectedPlan === FREE ? 'freeArrow' : '')
      })), /*#__PURE__*/React.createElement(Grid.Column, {
        width: "8"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        onClick: function onClick() {
          return _this3.handlePlanClick(PREMIUM);
        },
        primary: true
        /* eslint-disable-next-line max-len */
        ,
        className: "planButtonNarrow ".concat(this.state.selectedPlan === PREMIUM ? 'planSelected' : '')
      }, "Premium"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(this.state.selectedPlan === PREMIUM ? 'arrow' : '')
      }))))))), /*#__PURE__*/React.createElement(Grid, {
        className: "planDetails",
        columns: 3,
        divided: true
      }, /*#__PURE__*/React.createElement(Grid.Row, {
        verticalAlign: "middle"
      }, /*#__PURE__*/React.createElement(Grid.Column, {
        width: "15",
        textAlign: "center"
      }, "Monthly price")), /*#__PURE__*/React.createElement(Grid.Row, {
        className: "featureRow"
      }, !hideFreePlan && /*#__PURE__*/React.createElement(Grid.Column, {
        width: "8",
        textAlign: "center",
        className: this.columnClassName(FREE),
        style: this.columnColorStyle(FREE)
      }, freePlanMonthlyCost), /*#__PURE__*/React.createElement(Grid.Column, {
        width: "8",
        textAlign: "center",
        className: this.columnClassName(PREMIUM),
        style: this.columnColorStyle(PREMIUM)
      }, premiumPlanMonthlyCost))), featureRowNarrow)))), /*#__PURE__*/React.createElement(Divider, {
        hidden: true,
        className: "slim"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
        href: "".concat(REACT_APP_ENJOY_SITE_ROOT_URL, "/featurelist"),
        target: "_blank"
      }, "See all features details..."), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Divider, {
        hidden: true,
        className: "slim"
      }), (errors.length > 0 || errors.general) && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), /*#__PURE__*/React.createElement(Message, {
        size: "small",
        error: true,
        header: "Trouble with registration form...",
        list: _.concat(errors, errors.general)
      })), !dialogMode && /*#__PURE__*/React.createElement(Divider, {
        hidden: true
      }), dialogMode ? /*#__PURE__*/React.createElement(Grid, {
        columns: 2,
        className: "subscribePlans_dialog actionButtons"
      }, /*#__PURE__*/React.createElement(Grid.Row, {
        textAlign: "center",
        verticalAlign: "middle"
      }, /*#__PURE__*/React.createElement(Grid.Column, {
        width: "8"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        className: "square",
        onClick: function onClick() {
          return onContinueClick(null);
        },
        fluid: true
      }, "Cancel")), /*#__PURE__*/React.createElement(Grid.Column, {
        width: "8"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        className: "square",
        onClick: this.handleContinueClick,
        color: "blue",
        fluid: true
      }, "Submit")))) : /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        onClick: this.handleContinueClick,
        size: "large",
        primary: true,
        className: "subscribeNavigation square"
      }, "CONTINUE"), /*#__PURE__*/React.createElement("p", {
        className: "subscribeStepFooter",
        style: darkMode ? {} : {
          color: 'grey'
        }
      }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Enjoy features subject to availability for growing selection of shows.", /*#__PURE__*/React.createElement("br", null), "Not all shows have features available on each service provider.", /*#__PURE__*/React.createElement("br", null), "See the", ' ', /*#__PURE__*/React.createElement("a", {
        href: "".concat(REACT_APP_ENJOY_SITE_ROOT_URL, "/faq"),
        target: "_blank"
      }, "FAQ"), ' ', "and", ' ', /*#__PURE__*/React.createElement("a", {
        href: "".concat(REACT_APP_ENJOY_SITE_ROOT_URL, "/termsofuse"),
        target: "_blank"
      }, "Terms of Use"), ' ', "for more details.")));
    }
  }]);

  return Step1PlansMatrix;
}(React.Component);

Step1PlansMatrix.defaultProps = {
  onContinueClick: function onContinueClick() {
    return null;
  },
  // onTermsClick: () => null,
  updateSubscriptionLevel: null,
  // Must be null and not `() => null`
  planCode: FREE,
  user: undefined,
  userId: undefined,
  dialogMode: false,
  disableLowerPlanCodes: false,
  darkMode: false
};
export default Step1PlansMatrix;